import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { createUserStorage } from './userStorage'

export type WorkspaceLayoutMode = 'tile' | 'gallery' | 'split'

interface ProjectLayout {
  mode?: WorkspaceLayoutMode
  outerLayout?: number[]
}

interface WorkspaceLayoutState {
  entries: Record<string, ProjectLayout>
  setMode: (projectId: string, mode: WorkspaceLayoutMode) => void
  setOuterLayout: (projectId: string, outerLayout: number[]) => void
  getProjectLayout: (projectId: string) => ProjectLayout | null
}

export const useWorkspaceLayoutStore = create<WorkspaceLayoutState>()(
  persist(
    (set, get) => ({
      entries: {},
      setMode: (projectId, mode) =>
        set((state) => ({
          entries: {
            ...state.entries,
            [projectId]: { ...state.entries[projectId], mode },
          },
        })),
      setOuterLayout: (projectId, outerLayout) =>
        set((state) => ({
          entries: {
            ...state.entries,
            [projectId]: { ...state.entries[projectId], outerLayout },
          },
        })),
      getProjectLayout: (projectId) => get().entries[projectId] ?? null,
    }),
    {
      name: 'workspace-layout',
      storage: createUserStorage(),
    },
  ),
)

export const rehydrateWorkspaceLayoutStore = () =>
  useWorkspaceLayoutStore.persist.rehydrate()

export const resetWorkspaceLayoutStore = () =>
  useWorkspaceLayoutStore.setState({ entries: {} })
